import { createApp } from 'vue';
import PTable from '../../free/PTable.vue'

const appElements = document.querySelectorAll('.vue-free-planetry-table')

Array.from(appElements).forEach(element => {
  createApp(PTable).mount(element);
});